import { ResponsiveImage, Stack } from '@/components';
import { ModuleBaseModel, ModuleBaseNameProps, ModuleBasePropsModel } from '@/types';
import { animControllerInView, fadeIn } from '@/animations';
import SideBySideModule, { SideBySideModuleModel } from '../SideBySideModule/SideBySideModule';

export type FullPageSlideInfoBlockElementModel = {
  modules: ModuleBaseModel<ModuleBasePropsModel>[];
} & ModuleBaseNameProps;

const FullPageSlideInfoBlockElement = ({ modules }: FullPageSlideInfoBlockElementModel) => {
  if (!modules) return null;

  const firstModule = modules[0] as SideBySideModuleModel;

  const image = firstModule.props.image?.desktopImage;

  return (
    <div className="relative flex w-full flex-row">
      <div className="w-full lg:w-1/2">
        {modules.map((_module) => {
          const sideBySideModule = _module as SideBySideModuleModel;

          return <SideBySideModule key={sideBySideModule.id} {...sideBySideModule} />;
        })}
      </div>
      {image && (
        <Stack animation={animControllerInView({ amount: 0.3 })} className="hidden w-1/2 lg:block">
          <div className="sticky top-[var(--header-height)] h-[calc(100vh-var(--header-height))]">
            <div className="relative h-full w-full overflow-hidden">
              <ResponsiveImage
                animation={fadeIn}
                image={image}
                widths={{ xs: 1, sm: 1, md: 1, lg: 512, xl: 720, xxl: 1000 }}
                heights={{ xs: 1, sm: 1, md: 1, lg: null, xl: null, xxl: null }}
              />
              <div className="absolute top-2/4 left-2/4 aspect-square w-full -translate-x-2/4 -translate-y-2/4 rounded-full border border-white" />
            </div>
          </div>
        </Stack>
      )}
    </div>
  );
};

export default FullPageSlideInfoBlockElement;
